import { cn } from '@/platform/lib/utils';

const SegmentContent = ({ right = false, className, children, ...props }) => (
    <div
        className={cn(
            'px-6 py-4',
            right && 'flex items-center justify-end gap-2',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

export default SegmentContent;
